/**
 * Miscellaneous API Module
 * Handles contacts, announcements, favorites, uploads, and integrations
 * Part of API optimization - follows AIM atomicity principle
 */

import { api } from './client'
import { longRunningClient } from '../apiClient'

// Contact API
export const contactAPI = {
  submitContact: (data) => api.post('/contact', data)
}

// Announcement API
export const announcementAPI = {
  // Public endpoints
  getPublishedAnnouncements: (params) => api.get('/announcements', { params, silentError: true }),
  getAnnouncement: (id) => api.get(`/announcements/${id}`, { silentError: true }),
  
  // Admin endpoints
  getAllAnnouncements: (params) => api.get('/admin/announcements', { params }),
  createAnnouncement: (data) => api.post('/admin/announcements', data),
  updateAnnouncement: (id, data) => api.put(`/admin/announcements/${id}`, data),
  deleteAnnouncement: (id) => api.delete(`/admin/announcements/${id}`),
  publishAnnouncement: (id) => api.put(`/admin/announcements/${id}/publish`),
  unpublishAnnouncement: (id) => api.put(`/admin/announcements/${id}/unpublish`),
  togglePinAnnouncement: (id, isPinned) => api.put(`/admin/announcements/${id}/pin`, { isPinned }),
  
  // Translation endpoints
  getAnnouncementTranslations: (id) => api.get(`/admin/announcements/${id}/translations`)
}

// Favorites API
export const favoritesAPI = {
  addFavorite: (entityId, notes) => api.post(`/favorites/${entityId}`, { notes }),
  removeFavorite: (entityId) => api.delete(`/favorites/${entityId}`),
  getUserFavorites: (params) => api.get('/favorites', { params, silentError: true }),
  checkIsFavorite: (entityId) => api.get(`/favorites/check/${entityId}`, { silentError: true }),
  getFavoriteStats: () => api.get('/favorites/stats', { silentError: true }),
  toggleNotify: (entityId) => api.patch(`/favorites/${entityId}/notify`),
}

// Upload API - uses long-running client for file uploads
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData()
    formData.append('image', file)
    return longRunningClient.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

// Platform Integrations API (Slack, Discord)
export const integrationsAPI = {
  getIntegrations: () => api.get('/integrations'),
  unlinkSlack: () => api.delete('/integrations/slack'),
  unlinkDiscord: () => api.delete('/integrations/discord')
}

// City Pages Public API
export const cityAPI = {
  getCities: () => api.get('/cities', { silentError: true }),
  getCityPosts: (slug, lang = 'en') => api.get(`/cities/${slug}/posts`, { params: { lang }, silentError: true }),
  getCityPost: (citySlug, postSlug, lang = 'en') => api.get(`/cities/${citySlug}/posts/${postSlug}`, { params: { lang }, silentError: true }),
}

// Utility functions
export const uploadImage = async (file) => {
  const formData = new FormData()
  formData.append('image', file)
  
  const response = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  
  return response.data
}

export const geocodeAddress = async (address) => {
  try {
    const response = await api.get('/geocode', {
      params: { address }
    })
    return response.data
  } catch (error) {
    throw new Error('Geocoding failed')
  }
}
